/**
 * Normalise user-facing copy: replace em/en dashes in prose with natural English.
 * Date ranges like 1834–1917 become "1834 to 1917".
 */

export function formatProse(text) {
    if (typeof text !== "string" || !text) return text;

    return text
        .replace(/(\d{4})\s*[–—]\s*(\d{4})/g, "$1 to $2")
        .replace(/\s*—\s*/g, ", ")
        .replace(/\s*–\s*/g, " to ")
        .replace(/cultural–academic/gi, "cultural and academic");
}

export function cleanCopyDeep(value) {
    if (typeof value === "string") return formatProse(value);
    if (Array.isArray(value)) return value.map(cleanCopyDeep);
    if (value && typeof value === "object") {
        return Object.fromEntries(
            Object.entries(value).map(([k, v]) => [k, cleanCopyDeep(v)])
        );
    }
    return value;
}

/** Meta descriptions should stay within ~155–160 characters */
export function truncateMeta(text, max = 158) {
    if (!text || typeof text !== "string") return "";
    const clean = formatProse(text).replace(/\s+/g, " ").trim();
    if (clean.length <= max) return clean;
    const cut = clean.slice(0, max);
    const lastSpace = cut.lastIndexOf(" ");
    return `${(lastSpace > 80 ? cut.slice(0, lastSpace) : cut).trim()}…`;
}
